import styled, { css } from 'styled-components';

import { Divider } from '@useblu/ocean-react';

import { ShieldCheck } from '@useblu/ocean-icons-react';

import {
  colorInterfaceDarkUp,
  spacingInlineXs,
  spacingInlineXl,
  fontSizeXxxs,
  fontWeightMedium,
  spacingInsetXs,
  spacingStackSm,
  fontFamilyBase,
  spacingInlineXxs,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo, bpMedium } from 'tokens';

interface IButtonsProps {
  $expanded?: boolean;
}

const expandedStyles = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${spacingInsetXs};

  @media ${breakpointTo(bpMedium)} {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;

    button:nth-child(1) {
      order: 2;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  margin-top: ${spacingInlineXl};

  @media ${breakpointTo(bpMedium)} {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    margin-top: ${spacingStackSm};
  }
`;

export const CustomDivider = styled(Divider)`
  &&& {
    margin-top: ${spacingInlineXl};
    margin-bottom: ${spacingInlineXs};

    @media ${breakpointTo(bpMedium)} {
      display: none;
    }
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  gap: ${spacingInlineXxs};

  .back-button {
    margin-right: 8px;
  }

  @media ${breakpointTo(bpMedium)} {
    flex-direction: column-reverse;

    .back-button,
    .next-button {
      width: 100%;
    }
  }
`;

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex: 2;

  @media ${breakpointTo(bpMedium)} {
    flex: 1;
    justify-content: center;
    margin-top: ${spacingStackSm};
  }
`;

export const Buttons = styled.div<IButtonsProps>`
  display: flex;

  ${({ $expanded }) => $expanded && expandedStyles}
`;

export const ShieldIcon = styled(ShieldCheck)`
  &&& {
    margin-right: 8px;
    color: ${colorInterfaceDarkUp};
  }
`;

export const ActionText = styled.span`
  font-size: ${fontSizeXxxs};
  color: ${colorInterfaceDarkUp};
  font-weight: ${fontWeightMedium};
  font-family: ${fontFamilyBase};
`;
